document.addEventListener('DOMContentLoaded', function () {
    const whatsappCheckbox = document.getElementById('whatsapp_group');
    const hiddenButton = document.getElementById('hiddenButton');

    if (whatsappCheckbox && hiddenButton) {
        whatsappCheckbox.addEventListener('change', function () {
            hiddenButton.style.display = this.checked ? 'block' : 'none';
        });
    }
});
